import { DeviceType } from "@tether-web-portal/types/DeviceType";
import {
  DeviceCatalogIndex,
  DeviceCatalogResponse,
  DeviceTypeCapability,
} from "@tether-web-portal/types/DeviceTypeCapability";

/**
 * Module-level snapshot of the latest device-type catalog.
 *
 * `useDeviceCatalog` keeps this in sync with the fetched catalog so the synchronous device predicates
 * in `lib/utils/device.ts` (plain functions, not React hooks, called from non-component modules) can
 * read catalog capabilities. It's empty until the catalog first loads, so callers degrade gracefully
 * (predicates return false; icons fall back to unknown).
 */

export const indexByType = (catalog: DeviceCatalogResponse): DeviceCatalogIndex =>
  catalog.deviceTypes.reduce<DeviceCatalogIndex>((index, capability) => {
    index[capability.type] = capability;
    return index;
  }, {});

let cache: DeviceCatalogIndex = {};

export const setDeviceCatalogCache = (index: DeviceCatalogIndex): void => {
  cache = index;
};

export const getDeviceCatalogCache = (): DeviceCatalogIndex => cache;

export const getDeviceCapability = (deviceType?: string): DeviceTypeCapability | undefined =>
  deviceType ? cache[deviceType.toUpperCase() as DeviceType] : undefined;
